export const searchShipmentsEndpoint = '/shipments/search' as const
